/* eslint-disable-next-line */
export interface NotificationSettingsProps {}

export function NotificationSettings(props: NotificationSettingsProps) {
  return (
    <div>
      <h1>Welcome to NotificationSettings!</h1>
    </div>
  );
}

export default NotificationSettings;
